"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAY_DELAY = exports.MediaPlayer = void 0;
var MediaPlayer = exports.MediaPlayer = {
  isPlaying: true,
  //because the videoPlayer is set by default to autoplay
  seek: 0,
  volume: 0.8,
  // Default to 80% volume
  muted: false,
  // Default is muted
  loop: false
};

// Adding 2sec delay to account for network delay
var PLAY_DELAY = exports.PLAY_DELAY = 2;